<template>
	<div class="CaretLeft svgIcon" :style="{ width: size + 'px', height: size + 'px' }">
		<svg t="1697525596922" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="8385" :width="size" :height="size">
			<path d="M689 165.1L308.2 493.5c-10.9 9.4-10.9 27.5 0 37L689 858.9c14.2 12.2 35 1.2 35-18.5V183.6c0-19.7-20.8-30.7-35-18.5z" fill="#333333" p-id="8386"></path>
		</svg>
	</div>
</template>
<script setup name="CaretLeft">
	let props = defineProps({
		size: {
			type: [Number,String],
			default: () => 16
		}
	})
</script>
<style scoped lang="less">
	.CaretLeft,
	.svgIcon {
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
	}
</style>
